<template>
  <div class="ew-barchart">
    <div class="ew-barchart__empty" v-if="!items || items.length === 0">
      {{ emptyText }}
    </div>
    <div class="ew-barchart__row" v-for="(item, i) in items" :key="item.label" :title="`${item.label}: ${item.value}`">
      <span class="ew-barchart__label">{{ item.label }}</span>
      <div class="ew-barchart__track">
        <div
          class="ew-barchart__bar"
          :class="{ 'ew-barchart__bar--emphasis': i === 0 }"
          :style="{ width: barWidth(item.value) + '%' }"
        ></div>
      </div>
      <span class="ew-barchart__value">{{ item.value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HorizontalBarChart',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String,
      default: 'Sin datos en este periodo'
    }
  },
  computed: {
    maxValue () {
      return this.items && this.items.length > 0 ? this.items[0].value : 0
    }
  },
  methods: {
    barWidth (value) {
      if (!this.maxValue) return 0
      // Mínimo visible para que un valor pequeño frente al máximo no
      // desaparezca como una línea de 1-2px.
      return Math.max((value / this.maxValue) * 100, 4)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/app-tokens";

.ew-barchart {
  @include app-tokens;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.ew-barchart__row {
  display: grid;
  grid-template-columns: minmax(0, 9rem) 1fr 2.75rem;
  align-items: center;
  gap: 0.75rem;
}

.ew-barchart__label {
  font-family: var(--app-font);
  font-size: 0.82rem;
  color: var(--app-navy-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ew-barchart__track {
  background: var(--app-surface-muted);
  border-radius: 999px;
  height: 20px;
  overflow: hidden;
}

.ew-barchart__bar {
  height: 100%;
  background: var(--app-muted);
  border-radius: 0 4px 4px 0;
  transition: filter 0.15s ease;
}

.ew-barchart__bar--emphasis {
  background: var(--app-accent-button);
}

.ew-barchart__row:hover .ew-barchart__bar {
  filter: brightness(0.92);
}

.ew-barchart__value {
  font-family: var(--app-font);
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--app-navy);
  text-align: right;
}

.ew-barchart__empty {
  font-family: var(--app-font);
  font-size: 0.85rem;
  color: var(--app-muted);
  padding: 0.75rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/HorizontalBarChart.vue